"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    "aria-label": "search icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Search Icon'), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "icon_search_svg__a",
    d: "M14.657 2.571A6.705 6.705 0 007.96 9.27c0 1.518.508 2.919 1.363 4.043L3.11 19.524a1.047 1.047 0 101.482 1.481l6.242-6.242a6.657 6.657 0 003.823 1.203 6.705 6.705 0 006.697-6.697 6.705 6.705 0 00-6.698-6.698zm0 11.533a4.841 4.841 0 01-4.835-4.835 4.841 4.841 0 014.835-4.835 4.84 4.84 0 014.836 4.835 4.84 4.84 0 01-4.836 4.835zm1.376-8.17a.928.928 0 00-1.22.476.934.934 0 00.468 1.228c.047.022 1.16.54 1.033 1.486a.931.931 0 001.846.25c.252-1.87-1.218-3.042-2.127-3.44zm-.225 4.679a.93.93 0 00-.931.931.93.93 0 001.587.66.929.929 0 000-1.316.93.93 0 00-.656-.275z"
  })), /*#__PURE__*/_react.default.createElement("use", {
    transform: "matrix(-2.1562 0 0 2.13439 50.046 -1.488)",
    xlinkHref: "#icon_search_svg__a",
    width: "100%",
    height: "100%"
  }));
};

var _default = SvgIconSearch;
exports.default = _default;